import { StyledSpinner } from "./SpinnerStyle";

function Spinner() {
  return (
      <StyledSpinner />
  );
}

export default Spinner;
